import { useMemo, useState } from 'react';
import { apiBlobRequest } from '../apiClient';
import { buildUiHelpers } from './sharedUi';

export default function AccountDataExport({ COLORS, userId }) {
  const { Btn } = useMemo(() => buildUiHelpers({ COLORS, th: {} }), [COLORS]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  async function download() {
    setBusy(true);
    setError('');
    try {
      const blob = await apiBlobRequest(`/admin/users/${userId}/data-export`, { timeoutMs: 120000 });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `einfach-trading-daten-user-${userId}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }
  return <div>
    <Btn type="button" color="ghost" size="sm" onClick={download} disabled={busy || !userId}>{busy ? 'Export wird erstellt...' : 'Daten exportieren'}</Btn>
    {error && <p role="alert" style={{ color: COLORS.red }}>{error}</p>}
  </div>;
}
